import React from "react";
import "../../../styles/main.css";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";



const Page42 = () => {
  return (

   <div style={{ padding: 4 }}>
      {/* Fil d’ariane et Header */}
      <Breadcrumb
        items={[
          { label: "Accueil", href: "/HomePage" },
          { label: "Tableau de bord", href: "/dashboard" },
        ]}
      />
      <PageHeader
        title="Project"
        subtitle="Définissez les paramètres clés du projet"
        className="title-pulse"
      />
      <hr className="page-separator" />
      <main className="content">
        {/* Titre principal */}
        <h1>Gestion de projet - Statut du projet</h1>

        {/* Section d’introduction */}
        <section >
          <h2>Introduction</h2>
          <p>
            Ce projet consiste à développer un système intégré de gestion de la construction d’un bâtiment
            commercial. Les phases clés incluent la planification, l'exécution, le suivi et le contrôle de la qualité.
          </p>
          <p>
            L’objectif est de garantir le respect des délais, des budgets et des standards de sécurité.
          </p>
          <a href="#">En savoir plus sur le projet</a>
        </section>

        {/* Section avec listes */}
        <section >
          <h2>Phases du projet</h2>
          <h3>Planification</h3>
          <ul>
            <li>Établir le cahier des charges</li>
            <li>Analyser les ressources disponibles</li>
            <li>Définir les jalons et livrables</li>
          </ul>

          <h3>Exécution</h3>
          <ol>
            <li>Mobilisation des équipes</li>
            <li>Suivi des travaux et contrôle qualité</li>
            <li>Rapports hebdomadaires aux parties prenantes</li>
          </ol>
        </section>

        {/* Section avec inputs et formulaire */}
        <section>
          <h2>Formulaire d’avancement</h2>
          <p>Veuillez saisir les informations suivantes :</p>
          <input type="text" placeholder="Nom du responsable" />
          <br /><br />
          <textarea placeholder="Commentaires sur l’avancement" rows="4"></textarea>
          <br /><br />
          <select>
            <option>Phase 1 - Planification</option>
            <option>Phase 2 - Exécution</option>
            <option>Phase 3 - Clôture</option>
          </select>
          <br /><br />
          <button>Soumettre</button>
        </section>

        {/* Section avec titres multiples h4-h6 */}
        <section>
          <h2>Rapports détaillés</h2>
          <h4>Budget</h4>
          <p>Les coûts sont suivis et ajustés mensuellement pour chaque sous-projet.</p>

          <h5>Équipe</h5>
          <p>L’équipe est répartie sur plusieurs sites et coordonnée via des réunions quotidiennes.</p>

          <h6>Risques</h6>
          <p>
            Les risques identifiés incluent les retards fournisseurs et les conditions météo défavorables.
          </p>
        </section>

        {/* Section avec liste mixte et liens */}
        <section>
          <h2>Livrables et documents</h2>
          <ul>
            <li>Planification Gantt <a href="#">Télécharger</a></li>
            <li>Rapport d’avancement <a href="#">Télécharger</a></li>
            <li>Analyse des risques <a href="#">Télécharger</a></li>
          </ul>
        </section>
      </main>
    </div>


  );
};

export default Page42;
